/* eslint-disable jira/filename-case */
import type { HTMLAttributes } from 'react';
import { Skeleton as SkeletonComponent } from './Skeleton.tsx';
import { Spacer as SpacerComponent } from './Spacer.tsx';

export const SkeletonCompiled: ({
	children,
	className,
	height,
	width,
	style,
	...rest
}: HTMLAttributes<HTMLDivElement> & {
	height?: string | number;
	width?: string | number;
}) => JSX.Element = SkeletonComponent;

export const SpacerCompiled: ({
	children,
	className,
	height,
	style,
	...rest
}: HTMLAttributes<HTMLDivElement> & {
	height: string;
}) => JSX.Element = SpacerComponent;

export const Skeleton: ({
	children,
	className,
	height,
	width,
	style,
	...rest
}: HTMLAttributes<HTMLDivElement> & {
	height?: string | number;
	width?: string | number;
}) => JSX.Element = SkeletonComponent;

export const Spacer: ({
	children,
	className,
	height,
	style,
	...rest
}: HTMLAttributes<HTMLDivElement> & {
	height: string;
}) => JSX.Element = SpacerComponent;
